import { Fragment, useState } from "react";
import Button from "../../../student/components/generic/button";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { deltamathAPI } from "../../utils";
import { useDeltaToastContext } from "../../../shared/contexts/ToasterContext";
import { DMConfirmModal } from "../../../shared/DMModal/DMConfirmModal";

const SyncDistrict: React.FC<{
  entityID: string;
  entityName: string;
  timezone: string;
  entityType: "school" | "district";
}> = ({
  entityID,
  timezone,
  entityName,
  entityType,
}: {
  entityID: string;
  timezone: string;
  entityName: string;
  entityType: "school" | "district";
}) => {
  const toastContext = useDeltaToastContext();
  const [showSyncModal, setShowSyncModal] = useState(false);

  const { mutate: syncDistrict } = useMutation({
    mutationFn: async () => {
      const response = await axios.post(
        `${deltamathAPI()}/manager_new/invoices/sync_district`,
        { entityID, timezone, entityType }
      );
      return response;
    },
    onSuccess: () => {
      toastContext.addToast({
        status: "Success",
        message: `District synced successfully.`,
      });
    },
    onError: (error) => {
      const errorMessage = axios.isAxiosError(error)
        ? error.response?.data?.message || "An error occurred"
        : JSON.stringify(error);
      toastContext.addToast({
        status: "Error",
        message: `Failed to sync district: ${errorMessage}`,
      });
    },
    onSettled: () => {
      setShowSyncModal(false);
    },
  });

  const copy =
    entityType === "district"
      ? `Do you want to sync ${entityName} - ${entityID} - and its associated schools?`
      : `Do you want to sync the district of ${entityName} and other schools in the district?`;

  return (
    <Fragment>
      <Button className="mt-2" onClick={() => setShowSyncModal(true)}>
        Sync District
      </Button>
      <DMConfirmModal
        visible={showSyncModal}
        confirmText="Sync"
        onConfirm={syncDistrict}
        onCancel={() => setShowSyncModal(false)}
        title="Sync District"
        confirmButtonProps={{ type: "primary" }}
      >
        <div className="flex flex-col gap-4">{copy}</div>
      </DMConfirmModal>
    </Fragment>
  );
};

export default SyncDistrict;
